import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { FiscalYear } from '../types/fiscal-year';

interface FiscalYearState {
  currentFiscalYear: FiscalYear | null;
  setCurrentFiscalYear: (fiscalYear: FiscalYear | null) => void;
}

export const useFiscalYearStore = create<FiscalYearState>()(
  persist(
    (set, get) => ({
      currentFiscalYear: null,
      setCurrentFiscalYear: (fiscalYear) => {
        const prev = get().currentFiscalYear;
        set({ currentFiscalYear: fiscalYear });
        // Si l'exercice a réellement changé, invalider tous les caches
        if (prev?.id !== fiscalYear?.id) {
          invalidateAllCachesOnFYChange();
        }
      },
    }),
    {
      name: 'fiscal-year-storage',
    }
  )
);

/**
 * Invalidation globale des caches quand l'exercice fiscal change.
 * Utilise des imports dynamiques pour éviter les dépendances circulaires.
 */
async function invalidateAllCachesOnFYChange() {
  console.log('🔄 Exercice fiscal changé — invalidation de tous les caches');

  // Invalider le cache in-memory de ContextService
  try {
    const { ContextService } = await import('../services/ContextService');
    ContextService.invalidateCache();
  } catch (_) { /* ignore si le module n'existe pas */ }

  // Invalider le cache in-memory de ChartsApiService
  try {
    const { ChartsApiService } = await import('../services/chartsApi');
    ChartsApiService.clearCache();
  } catch (_) { /* ignore si le module n'existe pas */ }

  // Nettoyer les données dashboard de IndexedDB (elles sont scopées par FY)
  try {
    const { IndexedDBService } = await import('../services/storage/IndexedDBService');
    await IndexedDBService.clear('dashboard_data');
    await IndexedDBService.clear('dashboard_timeseries');
  } catch (_) { /* ignore */ }
}